// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"89765926","70":"4165af34","71":"9b23f4f2","195":"7fcb91ff","293":"a934b8a5","349":"a47c28c6","360":"3bd567a8","401":"71af96bb","419":"1720e5a1","606":"09f75d30","621":"c2af4303","635":"8011da75","832":"bbbdf632","870":"652539ea"}[chunkId] + ".chunk.js";
};